import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { fetchData } from "../../../api/cancuiApi";

const useProbabilityFlagBaseType = () => {
    const [cellText, setCellText] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        setLoading(true);
        fetchData("ProbabilityFlagBaseType")
            .then((res) => {
                if (res.objs && res.objs.length > 0) {
                    const data = res.objs.map(({
                        claddingorInsulationCondition,
                        coating_Status,
                        external_Environment,
                        heat_Tracing,
                        insulation_Type
                    }) => ({
                        claddingorInsulationCondition,
                        coating_Status,
                        external_Environment,
                        heat_Tracing,
                        insulation_Type
                    }));
                    setCellText(data);
                } else {
                    setCellText('No Data');
                }
            })
            .catch((error) => {
                console.error("Error fetching ProbabilityFlagBaseType:", error);
                toast.error("Error fetching ProbabilityFlagBaseType. Please try again later.");
            })
            .finally(() => {
                setLoading(false);
            });
    }, []);

    return { cellText, loading };
};


export default useProbabilityFlagBaseType;